import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Footer } from '@/components/Footer';

export const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 w-full max-w-2xl mx-auto px-4 py-12 sm:py-16 flex flex-col">
        {/* Main content */}
        <div className="flex-1 flex flex-col justify-center">
          {/* Label */}
          <p className="text-sm font-semibold tracking-widest text-helper mb-3 text-center uppercase">
            Daily Power Skills
          </p>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl font-bold text-h1 mb-4 text-center">
            One practical power skill at a time
          </h1>

          {/* Subline */}
          <p className="text-xl sm:text-2xl text-h2 font-medium mb-10 text-center">
            Spin the wheel for one small skill to practice today.
          </p>

          {/* Body text */}
          <div className="mb-12 max-w-xl mx-auto">
            <p className="text-body leading-relaxed text-center">
              Built for people rebuilding, job searching, networking, interviewing, or figuring out what comes next.
            </p>
            <p className="text-body leading-relaxed text-center mt-3 italic">
              Small reps count when life feels uncertain.
            </p>
          </div>

          {/* Two buttons side by side */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button
              onClick={() => navigate('/wheel')}
              className="px-8 py-3 h-auto text-base font-semibold bg-primary hover:bg-primary-hover text-primary-foreground"
            >
              Spin today&apos;s skill
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate('/demo')}
              className="px-8 py-3 h-auto text-base text-helper hover:text-body"
            >
              Try a demo spin
            </Button>
          </div>

          {/* Quiet text line */}
          <p className="text-sm text-helper text-center">
            Come back tomorrow for another spin.
          </p>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
